import { type NextPageWithLayout } from 'next'
import { useRouter } from 'next/router'
import React from 'react'
import ClientSignIn from 'components/ClientSignIn'
import { Box } from 'components/Layout'
import Link from 'components/Link'
import { Text } from 'components/Typography'
import { ROUTE } from 'constants/routes'
import { withGA4Provider } from 'hoc/withGoogleAnalytics'
import { GA4_PAGE_AREAS, GA4_SIGN_IN_AREAS } from 'providers/googleAnalytics'
import { COLOR_INTENT, SPACE } from 'Theme'

const SignInClientPage: NextPageWithLayout = () => {
  const { query } = useRouter()

  const returnUrl = query?.returnUrl

  return (
    <Box>
      <ClientSignIn />
      <Text
        as="p"
        color={COLOR_INTENT.SIGN_IN.TEXT}
        mt={SPACE.PX_22}
        textAlign="center"
      >
        New to The Expert?{' '}
        <Link
          href={ROUTE.SIGN_UP({
            fromUrl: GA4_SIGN_IN_AREAS.SIGN_IN_CLIENT,
            ...(returnUrl && !Array.isArray(returnUrl) && { returnUrl }),
          })}
        >
          Create client account.
        </Link>
      </Text>
    </Box>
  )
}

const SignInClient = withGA4Provider({
  page_area: GA4_PAGE_AREAS.SIGN_IN_CLIENT,
})(SignInClientPage)

export default SignInClient
